// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Series Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Series.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Series Create
/**
 *
 * @param {{ "name": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Series.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Series Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Series.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Series Update
/**
 *
 * @param  {{ "name": "string"}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Series.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Series Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Series.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
